import  React, {useState, useEffect, useRef, useMemo}        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import Style                                from "components/UI/main.module.scss";
import  {   getUserList,
            getUserByID,
            updateUser,
            getUserListBond,
            bondOperation
        }                                   from "./adminService";
import  {   GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            ValidateBusinessRules,
            SpinnerSmall,
        }                                   from "Utilities/utils";
import  {    DisplayGridDatetime
        }                                   from "components/Date/date"
import { useModal }                         from "components/Covers/genericModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { useSideContent }                   from "components/SideContent/sideContent";
import {ModalContent, ModalContentGoAction} from "components/Modal/modal";
import {TableGrid}                          from "components/Table/table";
import {SearchableDropdownList}             from "components/DropdownListField/dropdownListFIeld";
import  {   StatusFilter}                   from "components/Filter/statusFilter";
import  {   NeedSaveBlock}                  from "components/Validation/needSaveBlock";
import  {   LabelModule,
            IconHistory,
        }                                   from "components/Label/label";
import  {   getSystemStatusList,}           from "Services/service";
import { AccessDeniedContent } from "components/Content/accessContent";

let blank_user_obj          = {
    NeedSave:       false,
    UserId:         0,
    ModuleName:     "",
};
const Mithrandir            = [
    {value: "A", label: "Reitor"},
    {value: "B", label: "Pessoas e Organização"},
    {value: "C", label: "Administrador"},
    {value: "D", label: "Comum"},
];

const UserBondContent       = ({...setProps}) => {
    const { ContentType, 
            ShowModal,
            HideModal,
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);     
    // Loading State    
    const [ isLoading,  setIsLoading]            = useState(true);   // Loading fetch control
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def    
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const { showToastMessage}                    = useToastMessage();   // Toast message display
    const gridRef                                = useRef();
    const [ access,     setAccess]               = useState(false);

    const fetchBondList             = async ()          => {
        setIsLoading(true);
        try {
            let payload = await getUserListBond();
            if (payload) {
                if (payload.Status.Code == 0) {
                    setcolumnDefs(defaultCol);
                    setRowData(payload.Response.Content);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    };
    const datasetSelection          = ()                => {
        // Method for free version
        const selectedRows = [];
        gridRef.current.api.forEachNodeAfterFilter(node => {
            if (node.isSelected()) {
                selectedRows.push(node.data);
            }
        });
        return(selectedRows);
    };
    const handleOperation           = async (list)      => {
        setIsLoading(true);
        try {
            let payload = await bondOperation(list);
            if (payload) {
                if (payload?.Status?.Code === 0) {
                    showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});                
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }
            }
        }
        catch (error) {
            console.error(error);
        }        
        setIsLoading(false);
    };
    const OperationAction           = async (opr)       => {
        const rawData = datasetSelection();
        const dataSet = [];
        rawData.forEach(child => {
            dataSet.push(
                {   Operation: opr,
                    MentorId:  child.MentorUserId,
                    MenteeId:  child.MenteeUserId,                    
                    StatusId:  4
                }
            );
        });    
        let messages = [];
        if (dataSet?.length === 0 || dataSet === null || dataSet === undefined) {
            messages.push(GetSystemLabel("WarningSelectMore"));
        }
        if (messages.length > 0) {
            showToastMessage({header: GetSystemLabel("Attention"), message: messages});
        }
        else {
            await ShowModal(
                <ModalContentGoAction 
                    Message={GetSystemLabel("WarningQuestionProceed")}
                    Action={async () => {
                        HideModal();
                        setIsLoading(true);
                        await handleOperation(dataSet);
                        await fetchBondList();
                        setIsLoading(false);
                    }}
                />
            );
        }
    };    
    const gridOptions               = {
        rowSelection: { 
            mode: 'multiRow',
        },
    };
    const gridContext               = useMemo(() => ({
        datasetSelection: datasetSelection,
    }), []);
    const defaultCol                = [
        {
            headerName: GetBusinessLabel("TableHeaderPersonMentorData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Name"),                       field: "MentorUserFirstName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("LastName"),                  field: "MentorUserLastName"               ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("Email"),                      field: "MentorUserEmail"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
                { hide: false,lockVisible: true,  columnGroupShow: 'open',  headerName: GetBusinessLabel("Department"),               field: "MentorDepartmentName"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                
                { hide: false,lockVisible: true,  columnGroupShow: 'open',  
                    headerName: GetSystemLabel("History"),
                    field: "MentorHistory",
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" "),
                    cellRenderer: (params) => (
                        <IconHistory
                            Boolean={params?.data?.History === 1? true:false} 
                        />
                    ),
                },                    
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: GetSystemLabel("Identifier"),              field: "MentorUserId"                     ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                                                                                
            ]
        },    
        {
            headerName: GetBusinessLabel("TableHeaderPersonMenteeData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                           headerName: GetSystemLabel("Name"),                       field: "MenteeUserFirstName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("LastName"),                  field: "MenteeUserLastName"               ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Email"),                      field: "MenteeUserEmail"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
                { hide: false,lockVisible: true,  columnGroupShow: 'open',  headerName: GetBusinessLabel("Department"),               field: "MenteeDepartmentName"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                
                { hide: false,lockVisible: true,  columnGroupShow: 'open',  
                    headerName: GetSystemLabel("History"),
                    field: "MenteeHistory",
                    filter: true , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" "),
                    cellRenderer: (params) => (
                        <IconHistory
                            Boolean={params?.data?.History === 1? true:false} 
                        />
                    ),                    
                },                    
                { hide: false,lockVisible: true,   columnGroupShow: 'open',  headerName: GetSystemLabel("Identifier"),              field: "MenteeUserId"                     ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                                                                                
            ]
        },                   
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`    ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
            ]
        },        
    ].filter(Boolean);

    useEffect(() => {
        if (!isReady) {
            if(ValidateBusinessRules("A")) {
                setAccess(true);
                setIsReady(true);
                fetchBondList();
            }
            else {
                setIsReady(true);
            }
        }
    }, [ContentType, isReady]);

    return (
        access ?
            <React.Fragment>
                <div>
                    <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                        {GetBusinessLabel("BindApproval")}
                    </p>
                </div>
                {isLoading? 
                    <React.Fragment>
                        <div className={Style.overflow_hidden}>
                            <div className={Style.py_5}>
                                <Spinner/>
                            </div>
                        </div>
                    </React.Fragment>
                :
                    <React.Fragment>
                        <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control].join(" ")}>
                            <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                                <div    className={[Style.d_flex, 
                                                    Style.align_items_center, 
                                                    Style.justify_content_center,
                                                    Style.clickable,
                                                    Style.success_bg, 
                                                    Style.rounded_3, 
                                                    Style.border, 
                                                    Style.shadow_sm, 
                                                    Style.py_3,
                                                    Style.pop_item_animation].join(" ")}
                                    onClick={async () => await OperationAction(1)}
                                >
                                    <span className={[Style.fs_8, Style.text_white].join(" ")}>
                                        {GetSystemLabel("Approve")}
                                    </span>
                                </div>                                                        
                            </div>
                            <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                                <div    className={[Style.d_flex, 
                                                    Style.align_items_center, 
                                                    Style.justify_content_center,
                                                    Style.clickable,
                                                    Style.danger_bg, 
                                                    Style.rounded_3, 
                                                    Style.border, 
                                                    Style.shadow_sm, 
                                                    Style.py_3,
                                                    Style.pop_item_animation].join(" ")}
                                    onClick={async () => await OperationAction(2)}
                                >
                                    <span className={[Style.fs_8, Style.text_white].join(" ")}>
                                        {GetSystemLabel("Disapprove")}
                                    </span>
                                </div>                                  
                            </div>
                        </div>    
                        <div className={Style.row}>
                            <div className={Style.col}>
                                <TableGrid
                                    externalRef={gridRef}
                                    columnDefs={columnDefs}
                                    rowData={rowData}
                                    searchText={searchText}
                                    setSearchText={setSearchText}
                                    Options={gridOptions}
                                    gridContext={gridContext}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        :
            undefined
    );
};

const UserEdit              = ({...setProps}) => {
    const {
        ShowModal,
        UserData,
        ReFetchUserList 
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);   // Loading fetch control
    const [ userObj,         setUserObj]                         = useState(blank_user_obj);   // User Object
    const { showToastMessage            }                        = useToastMessage();   // Toast message display

    const handleSave = async    () => {
        setIsLoading(true);
        let payload = await updateUser(userObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                if (userObj.UserId === 0) {
                    setUserObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                            UserId : payload.Response.Content.UserId,
                        });
                    });
                }
                else {
                    setUserObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false
                        });
                    });                    
                }
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction = async    () => {
        let messages = [];
        if (userObj?.ModuleName === "" || userObj?.ModuleName === null || userObj?.ModuleName === undefined) {
            messages.push(GetBusinessLabel("WarningMessage0"));
        }
        if (messages.length > 0) {
            showToastMessage({header: GetSystemLabel("Attention"), message: messages});
        }
        else {
            await handleSave();
            await ReFetchUserList();
        }
    };
    const Vector      =         () => {
        const list = Mithrandir.map(d => ({
            value: d.value,
            label: d.label
        }));
        if (ValidateBusinessRules("C")) {
            return list.filter(d => d.value === "A");
        }
        return list;
    };
    const getValidValueOption = (arr, key, value) => {
        let l     = arr.length;
        for(let i = 0; i < l; i++) {
            if(arr[i][key] === value) {
                return(arr[i][key]);
            }
        }
        return undefined;
    };

    useEffect(() => {
        const fetchData = async (user_id) => {
            try {
                let payload = await getUserByID(user_id);
                if (payload) {
                    if (payload?.Status?.Code === 0) {
                        if (payload?.Response?.Content) {
                            const obj = payload?.Response?.Content;
                            setUserObj(prev => {
                                return({
                                    ...prev,
                                    ...obj
                                });
                            });
                            setIsLoading(false);
                        }
                    }
                    else {
                        ShowModal(<ModalContent Message={payload.Status.Message}/>);
                        setIsLoading(false);
                    }
                }
            } 
            catch (error) {
                setUserObj(blank_user_obj);
                setIsLoading(false);
            }
        };
        if (UserData?.UserId && UserData.UserId !== 0) {
            fetchData(UserData);
        } 
        else {
            setUserObj(blank_user_obj);
            setIsLoading(false);
        }
    }, [UserData]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={userObj?.NeedSave}/>
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>                                
                                {userObj?.FirstName} {userObj?.LastName}:
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>                                
                                {userObj?.Email}
                            </span>
                        </div>
                    </div>               

                    <div className={[Style.py_3].join(" ")}/>

                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Profile")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <SearchableDropdownList    
                                placeholder={GetSystemLabel("Profile")}                                
                                listOfItems={Vector()}
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}                              
                                onChange={(event) => {            
                                    setUserObj(prev => ({
                                        ...prev,
                                        NeedSave: true,
                                        ModuleName: event
                                    }));
                                }}
                                value={userObj?.ModuleName !== null ? getValidValueOption(Vector(), 'value', userObj?.ModuleName) : undefined}
                            />
                        </div>
                    </div>

                    <div className={[Style.py_3].join(" ")}/>
                            
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );

};
const UserContent           = ({...setProps}) => {
    const { ContentType, 
            ShowModal,
            HideModal,
            HideSideContent,
            StatusList,
            SearchStatus,
            SetSearchStatus,            
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);     
    // Loading State    
    const [ isLoading,  setIsLoading]            = useState(true);   // Loading fetch control
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def    
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    
    const reFetchUserList = async () => {
        try {
            let payload = await getUserList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_user_obj));
            obj_copy.UserId = props.data.UserId;
            ShowModal(
                <UserEdit 
                    HideSideContent={HideSideContent}
                    ShowModal={ShowModal} 
                    HideModal={HideModal}
                    UserData={obj_copy} 
                    ReFetchUserList={() => {reFetchUserList();}}
                />
            );
        };
        return(
            <>
                <div 
                    onClick={() => {handleData();}} 
                    className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[Style.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        {
            headerName: GetBusinessLabel("TableHeaderPersonData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Edit"),                     field: GetSystemLabel("Edit")                     ,cellRenderer: EditItem, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                { hide: false,lockVisible: true,                           headerName: GetSystemLabel("Name"),                       field: "FirstName"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("LastName"),                  field: "LastName"                   ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                          
                                            headerName: GetSystemLabel("Profile"),             
                                            field: "ProfileName",
                                            cellRenderer: (params) => (
                                                <LabelModule
                                                    value={params?.data?.ProfileName} 
                                                />
                                            ), 
                                            filter: false, 
                                            flex: 0, 
                                            cellClass: [Style.table_text_left].join(" ")
                },                
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Email"),                      field: "Email"                      ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
                { hide: false,lockVisible: true,                          headerName: GetBusinessLabel("Department"),               field: "DepartmentName"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,  
                { hide: false,lockVisible: true,
                                            columnGroupShow: 'open', 
                                            headerName: GetSystemLabel("History"),
                                            width: 100,
                                            wrapText: true,
                                            autoHeight: true,
                                            headerClass: Style.table_header_center, 
                                            field: "History",
                                            cellRenderer: (params) => (
                                                <IconHistory
                                                    Boolean={params?.data?.History === 1? true:false} 
                                                />
                                            ),
                                            cellClass: [Style.table_text_center].join(" ")
                },                    
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`    ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },             
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "UserId"                     ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetBusinessLabel("HiringDate"),        field: "HiredDate"                  ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                       
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
            ]
        },                     
    ].filter(Boolean);

    const fetchUserList = async () => {
        try {
            let payload = await getUserList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setcolumnDefs(defaultCol);
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            fetchUserList();
        }
    }, [ContentType, isReady]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("AdminPageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={fetchUserList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};
export const AdminPage      = () => {
    const [ contentType,    setContentType          ]       = useState(1);
    const [ mount,          setMount                ]       = useState(false);
    const [ statusList,     setStatusList           ]       = useState(null);    
    const { showSideContent, hideSideContent        }       = useSideContent();    
    const { showModal, hideModal                    }       = useModal();
    const { showLoader, hideLoader                  }       = useLoader();
    const [ access,     setAccess                   ]       = useState(false);
    const [searchStatus, setSearchStatus            ]       = useState({StatusIds: []});    
    
    const fetchStatusList = async () => {
        try {
            let data = await getSystemStatusList({type: 1});
            if (data) {
                setStatusList(data);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if(!mount) {
            if (ValidateBusinessRules("A") || ValidateBusinessRules("C")) {
                setAccess(true);
                fetchStatusList();
            }
            setMount(true);
        }
    }, [contentType]);

    return (
        access ? 
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control].join(" ")}>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(1)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 1) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 1) ? Style.text_decoration_underline   : null, 
                                    (contentType === 1) ? Style.fw_semibold                 : null,
                                    (contentType === 1) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetSystemLabel("Profile")}
                            </span>
                        </div>                            
                    </div>
                    {ValidateBusinessRules("A") && (
                        <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.vanilla_bg,
                                                Style.rounded_3,
                                                Style.shadow_sm,
                                                Style.clickable, 
                                                Style.py_3,
                                                Style.mx_1,
                                                Style.pop_item_animation].join(" ")}
                                onClick={() => setContentType(2)}
                            >
                                <span 
                                    className={[                                
                                        (contentType === 2) ? Style.text_body_active            : Style.text_body, 
                                        (contentType === 2) ? Style.text_decoration_underline   : null, 
                                        (contentType === 2) ? Style.fw_semibold                 : null,
                                        (contentType === 2) ? Style.fs_6                        : Style.fs_8,
                                    ].join(" ")}
                                >
                                    {GetBusinessLabel("Bind")}
                                </span>
                            </div>                                                        
                        </div>
                    )}
                </div>    
            {
                contentType === 1? 
                    <React.Fragment>
                        <UserContent 
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}
                        />
                    </React.Fragment>
                :   
                contentType === 2? 
                    <React.Fragment>
                        <UserBondContent 
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}                        
                        />
                    </React.Fragment>
                :                     
                    null
            }
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};